import { render, staticRenderFns } from "./newscontent.vue?vue&type=template&id=d5319d84"
import script from "./newscontent.vue?vue&type=script&lang=js"
export * from "./newscontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports